import classNames from 'classnames';
import { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

import { GenericErrorBoundary } from '../../../components/common-form/builder/form/GenericErrorBoundary';
import type { SelectedItem } from '../Component.connect';
import { CloseButton } from './Buttons';
import { PanelDetails } from './PanelDetails';

interface SidePanelProps {
  className: string;

  onClose: () => void;

  selected: SelectedItem;
  onReloadQuote: (isin: string) => void;
}

export const SidePanel: FC<SidePanelProps> = ({ className, onClose, selected, onReloadQuote }) => {
  const { formatMessage } = useIntl();
  const onReloadSecondaryQuote = useCallback(() => {
    logAnalytics.trackEvent('Blotter Secondary Market trades', 'Open product');
    onReloadQuote(selected.isin);
  }, [onReloadQuote, selected.isin]);

  return (
    <div className={classNames('card d-flex flex-column', className)}>
      <div className="card-header">
        <div className="w-100 d-flex flex-row align-items-center justify-content-start">
          <h6>{formatMessage({ id: 'secondaryMarketBlotter.details.title' })}</h6>
          <div className="flex-grow-1 text-end">
            <CloseButton onClicked={onClose} />
          </div>
        </div>
      </div>
      <div className="card-body flex-grow-1 flex-shrink-1 overflow-y-auto">
        <GenericErrorBoundary key={selected.quoteId} context={{ quoteId: selected?.quoteId ?? '' }}>
          <PanelDetails item={selected} />
        </GenericErrorBoundary>
      </div>
      <div className="card-footer d-flex">
        {
          <button
            type="button"
            className="btn btn-xl btn-discreet-primary btn-icon-start w-100"
            onClick={onReloadSecondaryQuote}
          >
            <span>{formatMessage({ id: 'secondaryMarketBlotter.buttons.secondaryMarket' })}</span>
          </button>
        }
      </div>
    </div>
  );
};

SidePanel.displayName = 'SidePanel';
